<h3>Bedankt voor het registreren</h3>
<p> Venster Techniek neemt voor verdere informatie contact met u op.</p>
<div class="login-button">
  <button mat-stroked-button color="accent" [routerLink]="['/login']">Login</button>
</div>
